<video #videoControl  (error)="waitAndReload()">
    <source [src]="srcWebm" type="video/webm">
    <source [src]="srcOgv" type="video/ogg">
    <source [src]="srcMp4" type="video/mp4">
</video>